// Popups team
document.querySelectorAll('.faq-button').forEach(item => {
    item.addEventListener('click', event => {
        let answerContainer = document.getElementById('faq-' + item.dataset.id);
        let cursorContainer = document.getElementById('faq-cursor-' + item.dataset.id);

        answerContainer.classList.toggle('hidden');

        if (cursorContainer.classList.contains('rotate-0')) {
            cursorContainer.classList.replace('rotate-0', '-rotate-180')
        } else {
            cursorContainer.classList.replace('-rotate-180', 'rotate-0')
        }
    })
})
